import type React from "react";
import { cn } from "../utils/cn";

interface AnalystsIconProps extends React.SVGProps<SVGSVGElement> {
  className?: string;
  title?: string;
  dark?: boolean;
}

export function StudioIcon({ className, title = "Studio Icon", dark, ...props }: AnalystsIconProps) {
  // Ensure title is never empty for accessibility
  const accessibleTitle = title || "Studio Icon";

  return (
    <svg
      className={cn(className)}
      aria-label={accessibleTitle}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>{accessibleTitle}</title>
      <path
        d="M16.667 13.6162C17.0338 13.6163 17.3852 13.7621 17.6445 14.0215C17.9039 14.2808 18.0497 14.6323 18.0498 14.999V16.999C18.0498 17.3659 17.904 17.7181 17.6445 17.9775C17.3852 18.2368 17.0337 18.3827 16.667 18.3828H3.33301C3.01219 18.3827 2.70307 18.2709 2.45703 18.0693L2.35547 17.9775C2.09604 17.7181 1.9502 17.3659 1.9502 16.999V14.999C1.95028 14.6323 2.09612 14.2808 2.35547 14.0215L2.45703 13.9297C2.7031 13.7281 3.01212 13.6163 3.33301 13.6162H16.667ZM3.38379 16.9492H16.6162V15.0498H3.38379V16.9492ZM16.667 7.61621C17.0338 7.6163 17.3852 7.76214 17.6445 8.02148C17.9039 8.28083 18.0497 8.63226 18.0498 8.99902V10.999C18.0498 11.3659 17.904 11.7181 17.6445 11.9775C17.3852 12.2368 17.0337 12.3827 16.667 12.3828H3.33301C3.01219 12.3827 2.70307 12.2709 2.45703 12.0693L2.35547 11.9775C2.09604 11.7181 1.9502 11.3659 1.9502 10.999V8.99902L1.95703 8.8623C1.98854 8.54575 2.12855 8.2484 2.35547 8.02148L2.45703 7.92969C2.7031 7.72809 3.01212 7.61629 3.33301 7.61621H16.667ZM3.38379 10.9492H16.6162V9.0498H3.38379V10.9492Z"
        fill={dark ? "white" : "black"}
        stroke={dark ? "white" : "black"}
        stroke-width="0.1"
      />
      <path d="M9.25 4.25H7.5V2.75H9.25V1H10.75V2.75H12.5V4.25H10.75V6H9.25V4.25Z" fill={dark ? "white" : "black"} />
    </svg>
  );
}

export default StudioIcon;
